import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { reduxForm, Field, SubmissionError } from 'redux-form'
import { localize } from 'helpers/translator'
import { validateEmail } from 'helpers/validations'

import TextInputForm from 'components/input/text/text_input_form'
import SecondaryTitle from 'components/title_secondary/title_secondary'
import { MainButton } from 'components/button'

import styles from './admin_onboarding_add_user_form.scss'

const validate = values => {
	const errors = {}
	if (values.email) {
		if (!validateEmail(values.email)) {
			errors.email = localize('mail_invalid_domain')
		} else if (values.email.length > 80) {
			errors.email = localize('global_form_email_too_long')
		}
	} else {
		errors.email = localize('global_form_emailIsRequired')
	}
	if (!values.firstName || values.firstName.trim() === '') {
		errors.firstName = localize('global_form_firstNameIsRequired')
	}
	if (!values.lastName || values.lastName.trim() === '') {
		errors.lastName = localize('global_form_lastNameIsRequired')
	}

	return errors
}

class AdminOnboardingAddUserForm extends Component {

	constructor() {
		super()
		this.formCancelHandler = this.formCancelHandler.bind(this)
		this.formSubmitHandler = this.formSubmitHandler.bind(this)
	}

	formCancelHandler() {
		this.props.formCancelHandler.bind(this, 'AddUserForm')()
	}

	getFieldStatus(field, name, value) {
		if (field.touched && (field.invalid || value === '') && !field.active && field.visited) {
			return 'error'
		} else if (value !== '' && !field.invalid && !field.active && field.visited
				&& ['firstName', 'lastName', 'email'].includes(name)) {
			return 'success'
		} else {
			return ''
		}
	}

	formSubmitHandler(values) {
		return new Promise((resolve, reject) => {
			this.props.addUser(values, resolve, reject)
		})
			.then(() => {
			}).catch(function(err) {
				throw new SubmissionError({...err})
			})
	}

	getFieldMessage(field) {
		return field.error
	}

	render() {

		return (
			<div styleName='wrapper'>
				<div styleName='header'>
					<SecondaryTitle isCentered={true}>{localize('admin_onboarding_express_add_colleague_2')}</SecondaryTitle>
					<h3 styleName='subtitle'>{localize('admin_onboarding_express_colleague_invitation_2')}</h3>
				</div>
				<div>
					<form styleName='form' id='addUserForm' onSubmit={this.props.handleSubmit(this.formSubmitHandler)}>
						<div styleName='two-cols'>
							<div styleName='field'>
								<label styleName='field-label'>{localize('admin_onboarding_invite_teachers_form_first_name')}</label>
								<Field
									name="firstName"
									component={TextInputForm}
									type="text"
									props={{
										placeholder: localize('admin_onboarding_invite_teachers_form_first_name_placeholder'),
										fieldStatus: this.getFieldStatus,
										getMessage: this.getFieldMessage,
										tabIndex: 1,
										icons: {active: true},
									}}
								/>
							</div>
							<div styleName='field'>
								<label styleName='field-label'>{localize('admin_onboarding_invite_teachers_form_last_name')}</label>

								<Field
									name="lastName"
									component={TextInputForm}
									type="text"
									props={{
										placeholder: localize('admin_onboarding_invite_teachers_form_last_name_placeholder'),
										fieldStatus: this.getFieldStatus,
										getMessage: this.getFieldMessage,
										tabIndex: 2,
										icons: {active: true},
									}}
								/>
							</div>
						</div>
						<div styleName='field'>
							<label styleName='field-label'>{localize('admin_onboarding_invite_teachers_form_email')}</label>
							<Field
								name="email"
								component={TextInputForm}
								type="text"
								props={{
									placeholder: localize('admin_onboarding_invite_teachers_form_email_placeholder'),
									fieldStatus: this.getFieldStatus,
									getMessage: this.getFieldMessage,
									tabIndex: 3,
									icons: {active: true},
								}}
							/>
						</div>
						<div styleName='btn-bar'>
							<div styleName='btn-bar-button'>
								<MainButton tabIndex={5} focus={true} type='submit'>{localize('admin_onboarding_invite_teachers_form_save')}</MainButton>
							</div>
						</div>
					</form>
				</div>
			</div>
		)
	}
}

const DecoratedAdminOnboardingAddUserForm = reduxForm({
	form: 'AddUserForm',
	fields: ['firstName', 'lastName', 'email'],
	validate,
})(CSSModules(AdminOnboardingAddUserForm, styles, {allowMultiple: true}))

export default (DecoratedAdminOnboardingAddUserForm)
